
/* ==========================================================================

Purpose: 
This file handles the logic of: 
    - add-to-project-list.liquid
    - add-to-project-button-liquid,
    - add-to-project-tool.liquid

Features:
    - Removes products from the "Project List" page after 7 days has passed 
    - Adds a product to the page. Contains data on id, sku, title, image, description, quantity, productUrl
    - Updates numerical counter when products are added to the page. 
    - Renders display of page depending on page stage (empty, project list overview)
        - Dynamically changes product data used in building product card(s)
    - Supports incrementing and decrementing of product quantity
    - Deletes products 
    - Supports persistence of data when users close the tab or navigate to different pages.
    - Generates a downloadable PDF file 
    - Notifies when a product is added (or already added) to the Project List

Helpers created:
    - setExpiry()
    - getExpiry()
    - checkStorage()
    - updateCounter()
    - convertToBase64()
    - createMargins()
    - setLineHeight()
    - createUpdate()

Note:
*Assumes user is not logged in.
- Renders at theme.liquid, Line 426
- ttl stands for time to live
========================================================================== */

getExpiry('productExpiry');

function setExpiry(key, value, ttl) {
    const now = new Date();
    const productObj = {
        value: value,
        expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(productObj));
}

function getExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null
    }

    const productObj = JSON.parse(itemStr);
    const now = new Date();
    if ( now.getTime() > productObj.expiry) {
        localStorage.removeItem(key);
        localStorage.removeItem('projectItems');
        return null
    }
    return productObj.value;
}

function checkStorage() {
    let projectItems; // Inititalises variable     
    const temp = localStorage.getItem('projectItems'); 

    if (temp == null) { 
        projectItems = []; // Creates a new empty array
    } else {
        projectItems = JSON.parse(temp); // Converts information into an array and loads it
    }
    return projectItems;
}

function updateCounter(projectItems) {
    let numOfProducts = projectItems.reduce((total , item) => total + item.quantity, 0); // Returns number of products in array
    const myProjectBtn = document.querySelector('.project-button-counter'); 
    if (!myProjectBtn) return; 

    myProjectBtn.textContent = numOfProducts;

    if ( numOfProducts === 0) {
	    document.querySelector('.project-button-counter').style.display = 'none';
    } else {
        if (numOfProducts >= 1) {
            document.querySelector('.project-button-counter').style.display = 'block';
        }
    }
}

function convertToBase64(blob) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.readAsDataURL(blob);
    })
}

function createMargins(doc) {
    const margin = 12.7; // 0.5 inch in mm 
    const pageHeight = doc.internal.pageSize.getHeight(); 
    const pageWidth = doc.internal.pageSize.getWidth();

    const top = margin;
    const bottom = pageHeight - margin;
    const left = margin;
    const right = pageWidth - margin;

    return {
        top, bottom, left, right
    }; 
}

function setLineHeight() {
    const rows = [];
    let y = 46; // Starting point
    for (let i = 0; i < 3; i++) {
        y += 6;
        rows.push(y);
    }
    return rows;
}

function setFooterLineHeight() {
    const rows = [];
    let y = 264; // Starting point
    for (let i = 0; i < 4; i++) {
        y += 6;
        rows.push(y);
    }
    return rows;
}

function createUpdate(message, eventType, duration) {
    // Displays notification outcome
    let output = {
        success: `<span class="update-display">product-notification</span>`,
        error: `<span class="update-display">product-notification</span>`,
        info: `<span class="update-display">product-notification</span>`,
    };

    // Creates notification layout
    let box = document.createElement("div");
    box.classList.add("update", `update-${eventType}`);
    box.innerHTML=`<div class="update-content-wrapper">
                        <div class="update-message">${message}</div>
                        <div class="update-progress"></div>
                    </div>`;
    duration = duration || 5000;
    let boxProgress = box.querySelector(".update-progress");
    boxProgress.style.animationDuration = `${duration/1000}s`;

    let updatedAlready = document.body.querySelector(".update");
    if (updatedAlready) {
        updatedAlready.remove();
        boxProgress.style.animationDuration = "0s";
    } 

    document.body.appendChild(box);
}

if (document.querySelector('.add-to-project-list-btn')) {
    (function() {
        let addToProjButton = document.querySelector('.add-to-project-list-btn'); // Finds button from add to project list file
        const projectItems = checkStorage();
        updateCounter(projectItems);
        
        addToProjButton.addEventListener("click", function(e) {
            const productObj = { // creates a new object that contains id, sku, title & image
                productId: e.currentTarget.dataset.id,
                productSku: e.currentTarget.dataset.sku,
                productTitle: e.currentTarget.dataset.title,
                productImage: e.currentTarget.dataset.image,
                productDescription: e.currentTarget.dataset.description,
                quantity: 1,
                productUrl: e.currentTarget.dataset.url,
            }

            const found = projectItems.find(productObj => productObj.productId === e.currentTarget.dataset.id);

            if (found) {
                createUpdate(`Product ${productObj.productSku} has already been added.`, "error", 5000);
            } else {
                projectItems.push(productObj); // Adds productObj into projectItems array
                localStorage.setItem('projectItems', JSON.stringify(projectItems)); // Save updated array into local storage
                updateCounter(projectItems);
                createUpdate(`Product ${productObj.productSku} is added.`, "success", 5000);
                if (!getExpiry('productExpiry')) {
                    setExpiry('productExpiry', true, 604800000); // Sets an expiry date of 7 days for products without one
                }
            }
        });
    })();
}

function renderBoard() {
    const temp = localStorage.getItem('projectItems'); 
    const tempArr = temp ? JSON.parse(temp) : [];

    if (tempArr.length === 0) {
        document.querySelector('.empty-state').style.display = 'flex';
        document.querySelector('.form-container').style.display = 'none';
        document.querySelector('.board').style.display = 'none';
        document.querySelector('.continue-btn').style.display = 'none';
        document.querySelector('.explore-btn').style.display = 'flex';
        document.querySelector('.download-file').style.display = 'none';
        document.querySelector('.view-file').style.display = 'none';
        document.querySelector('.divider').style.display = 'none';
    } else {
        document.querySelector('.empty-state').style.display = "none";
        document.querySelector('.form-container').style.display = 'block';
        document.querySelector('.board').style.display = 'flex';
        document.querySelector('.continue-btn').style.display = 'flex';
        document.querySelector('.explore-btn').style.display = 'none';
        document.querySelector('.download-file').style.display = 'flex';
        document.querySelector('.view-file').style.display = 'flex';
        document.querySelector('.board').innerHTML = '';
        
        tempArr.forEach(element => {
            const newCard = document.createElement('div');
            newCard.dataset.id = element.productId;
            newCard.className = 'product-card';
            newCard.innerHTML =  `
                <div class="card-wrapper">
                    <div class="card-container"> 
                        <div class="card__item one-half">
                            <img class="product-image" src="${element.productImage}">
                        </div>
                        <div class="card__item one-half-right">
                            <h4 class="product-heading">
                                <a href="${element.productUrl}">${element.productTitle}</a>
                            </h4>
                            <p class="product-sku">Part Number: ${element.productSku}</p>
                            <div class="quantity-container">
                                <button class="decrement-btn">-</button>
                                <h5 class="quantity-counter">${element.quantity}</h5>
                                <button class="increment-btn">+</button>
                            </div>
                        </div>
                        <div class="delete-container">
                            <button class="delete-btn" data-id="${element.productId}" aria-label="delete-product">x</button>
                        </div>     
                    </div>
                </div>
            `
            document.querySelector('.board').appendChild(newCard);
        });
    }
}


if (document.querySelector('.board')) {
    renderBoard();
    let board = document.querySelector('.board');
    const projectItems = checkStorage();
    updateCounter(projectItems);

    board.addEventListener("click", function(e) {
        const card = e.target.closest('.product-card');
        if (!card) return;

        const productId = card.dataset.id;
        const counter = card.querySelector('.quantity-counter');
        const currentValue = parseInt(counter.innerText);
        const projectItems = checkStorage();
        const found = projectItems.find(productObj => productObj.productId === card.dataset.id);
        
        if (e.target.classList.contains('decrement-btn')) {
            if (currentValue > 1) {
                counter.innerText = currentValue - 1;
                found.quantity = currentValue - 1;
            } 
            
        } else {
            if (e.target.classList.contains('increment-btn')) {
                counter.innerText = currentValue + 1;
                found.quantity = currentValue + 1;
            }
        }
        localStorage.setItem('projectItems', JSON.stringify(projectItems));
        updateCounter(projectItems);
    })

    let deleteFromProjectBtn = document.querySelector('.board');                      

    deleteFromProjectBtn.addEventListener("click", function(e) {
        if (e.target.classList.contains('delete-btn')) {
            let projectItems = checkStorage();
            
            projectItems = projectItems.filter((item) => item.productId !== e.target.dataset.id);
            localStorage.setItem('projectItems', JSON.stringify(projectItems)); // Save updated array into local storage
            updateCounter(projectItems);
            renderBoard();
        }
    });
}

// Ensures data persists when page is refreshed
const exists = document.querySelector('.project-button-counter');

if (exists) {
    const projectItems = checkStorage();
    updateCounter( projectItems); 
}



async function generatePDF() {
    const { jsPDF } = window.jspdf; // Extracts jsPDF from window jsPDF
    const doc = new jsPDF({
        compress: true 
    }); // Creates a new jsPDF document by making an instance of jsPDF

    const m = createMargins(doc); // Passes doc as a parameter to retrieve function
    const projectItems = checkStorage();
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();

    doc.setFillColor(255);
    doc.rect(0, 0, width, height, "F");

    doc.setFillColor(0);
    doc.rect(0, 0, width, 30, "F");

    // Initialises and creates logo
    const response = await fetch ("https://cdn.shopify.com/s/files/1/0080/5067/1734/files/HCP-LOGO-WHITE.png?v=1779333273"); // Fetches logo URL path
    const blob = await response.blob(); // Turns response into a binary data object
    const base64 = await convertToBase64(blob);
    doc.addImage(base64, 'PNG', m.left, 8, 23, 15);

    // Stores the input value of users'details
    const projInfo = document.querySelector('#project-name').value;
    const nameInfo = document.querySelector('#name').value;
    const phoneInfo = document.querySelector('#phone').value;
    const emailInfo = document.querySelector('#email').value;
    
    // Right section
    doc.setTextColor(255);
    doc.setFontSize(15)
    doc.setFont('helvetica', 'bold');
    doc.text("Project List", m.right, 15 , {align: "right"});
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12)
    doc.text(projInfo, m.right, 22 , {align: "right"});

    // Initialising and creating Product Images 
    const productImage = await Promise.all(
        projectItems.map(async (item) => {
            const photo = await fetch(item.productImage); // Fetches product image
            const photoBlob = await photo.blob(); // Converts into binary object
            const productPhoto = await convertToBase64(photoBlob); // Turns into base 64
            return productPhoto;
        })
    )

    doc.setTextColor(0);
    doc.setFontSize(13);
    doc.setFont("helvetica", 'bold');
    doc.text("Summary", m.left, 43,{ align: 'left'}); 

    const infoX = m.left + 35;  // Positions information for x coordinate
    const rows = setLineHeight();
    
    // Form 
    doc.setTextColor(0);
    doc.setFont("helvetica", 'bold');
    doc.setFontSize(10);
    doc.text("Project Name:", m.left, rows[0], {align: "left"});
    doc.text("Name:",  m.left, rows[1], {align: "left"});
    doc.text("Phone Number:", m.left, rows[2], {align: "left"});
    doc.text("Email:", (m.left + 100), rows[0], {align: "left"});             

    doc.setFont("helvetica", 'normal');
    doc.text(projInfo, infoX, rows[0], {align: "left"});
    doc.text(nameInfo, infoX, rows[1], {align: "left"});
    doc.text(phoneInfo, infoX, rows[2], {align: "left"});
    doc.text(emailInfo, (m.left + 135), rows[0], {align: "left"});

    // Date and time
    doc.setFont('helvetica', 'normal');
    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    let hours = date.getHours();
    let min = date.getMinutes();
    let sec = date.getSeconds().toString().padStart(2, '0');

    doc.setFont("helvetica", 'bold');
    doc.text("Generated:", (m.left + 100), rows[1], {align: 'left'});
    doc.setFont("helvetica", 'normal');
    doc.text(`${day}/${month}/${year} ${hours}:${min}:${sec}`, (m.left + 135), rows[1], {align: 'left'});

    // Table on products added 
    doc.autoTable({
        startY: 73, 
        head: [["Product", "SKU", "Description", "Quantity"]],
        body: projectItems.map((item) => [
            "", // didDrawCell handles image column
            item.productSku.trim() || "",
            item.productDescription.replace(/<[^>]*>/g, "").trim().replace(/\n{2,}/g, '\n') || "", // Removes HTML tags, leading/trailing lines and white space characters 
            item.quantity || "",
        ]),
        margin: { bottom: 60, left: m.left, right: m.left },
        theme: 'plain',
        headStyles: {
            textColor: 245,
            fillColor: 0,
            halign: 'left',
            fontSize: 10
        },
        bodyStyles: {lineWidth: 0, minCellHeight: 50, fontWeight:'bold', fontSize: 10, valign: 'middle'},
        tableWidth: 'auto',
        columnStyles: {
            0: { cellWidth: 38},
            2: { cellWidth: 70},
            3: { halign: 'center'}
        },

        didDrawCell: function(cell) {
            // Draws border
            doc.setDrawColor(200);
            doc.setLineWidth(0.3);
            doc.line(
                cell.cell.x,
                cell.cell.y + cell.cell.height,
                cell.cell.x  + cell.cell.width,
                cell.cell.y + cell.cell.height
            );

            // Draws product image(s)
            if (cell.row.section === 'body' && cell.column.index === 0) {
                const image = productImage[cell.row.index];
                if (!image) return ;
                doc.addImage(
                    image,
                    'UNKNOWN',
                    cell.cell.x + (cell.cell.width/2) - 15,
                    cell.cell.y + (cell.cell.height/2) - 15,
                    30, 
                    30 
                );
            }  
        },
        
    });

    // Initalises QR Reseller Image
    const resellerLocator = await fetch ("https://cdn.shopify.com/s/files/1/0080/5067/1734/files/HCP_Store_Locator.png?v=1781504707"); // Fetches logo URL path
    const resellerBlob = await resellerLocator.blob();
    const storeImg = await convertToBase64(resellerBlob);

    const pageCount = doc.getNumberOfPages();
    const rowsY = setFooterLineHeight();

    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);

        // Footer 
        doc.setTextColor(0);
        doc.setFontSize(10);
        doc.text("Havit Commercial", m.left, rowsY[0], {align: "left"});
        doc.text("U8/133 Beauchamp Road, Matraville. NSW 2036 Australia", m.left, rowsY[1], {align: "left"});
        doc.text("+61 (02) 9381 8383", m.left, rowsY[2], {align: "left"});
        doc.text("sales@havitcommercial.com.au", m.left, rowsY[3], {align: "left"});

        doc.addImage(storeImg, 'PNG', (m.right - 23), 265, 23, 23); // Positions QR Code
        doc.setFontSize(10);
        doc.text("Scan for Reseller Locator", 163, 275, { align: 'center', maxWidth: 15 }); 
    }

    var fileName = projInfo + "-Commercial-Project-List.pdf";

    doc.setProperties({ 
        title: fileName,
        author: 'Havit Commercial',
        subject: 'Havit Commercial', 
        creator: 'Havit Commercial'
    }); 

    return {
        doc: doc,
        fileName: fileName
    };
}


function createDownloadAnchor(blob, fileName) {
    var pdfUrl = URL.createObjectURL(blob);
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) { 
        window.open('','_blank');
    }

    var anchor = document.createElement('a');
    anchor.href = pdfUrl;
    anchor.download = fileName;
    anchor.setAttribute('download', fileName);
    anchor.style.display = 'none';

    document.body.appendChild(anchor);
    anchor.click();

    setTimeout(function () {
        document.body.removeChild(anchor);
        URL.revokeObjectURL(pdfUrl);
    }, 700);
}

function openPreview(blob, fileName) {
    var browserUrl = URL.createObjectURL(blob);
    var previewWindow = window.open('', '_blank');
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!previewWindow) {  // Raises a comment
        alert('Please allow pop-ups to preview the PDF');
        return;
    }

    // Embeds a window within a new window to display pdf
    previewWindow.document.title = fileName;
    var preview = previewWindow.document.createElement('iframe');
    var previewBar = previewWindow.document.createElement('div');
    previewBar.className = 'project-tool-preview-bar';
    
    var previewName = previewWindow.document.createElement('div');
    previewName.className = 'project-tool-preview-name';

    var downloadFile = previewWindow.document.createElement('a');
    downloadFile.className = 'project-tool-download-file';
    downloadFile.href = browserUrl;
    downloadFile.download = fileName;
    downloadFile.setAttribute('download', fileName);
    downloadFile.textContent = 'Download PDF';

    var iframe = previewWindow.document.createElement('iframe');
    iframe.src = browserUrl + '#toolbar=0&navpanes=0&scrollbar=1';
    iframe.title = fileName;

    var customStyle = previewWindow.document.createElement('style');
    customStyle.textContent =
    'html,body{margin:0;height:100%;background:#1f1f1f;font-family:Arial,sans-serif;overflow:hidden;}' +
    '.project-tool-preview-bar{height:54px;background:#030303;color:#fff;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:0 18px;box-sizing:border-box;border-bottom:1px solid #333;}' +
    '.project-tool-preview-name{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:13px;font-weight:700;}' +
    '.project-tool-download-file{background:#fff;color:#000;text-decoration:none;font-size:12px;font-weight:800;padding:10px 16px;text-transform:uppercase;letter-spacing:.08em;white-space:nowrap;}' +
    'iframe{width:100%;height:calc(100% - 54px);border:0;background:#fff;display:block;}';

    previewWindow.document.head.appendChild(customStyle);
    previewBar.appendChild(previewName);
    previewBar.appendChild(downloadFile);
    previewWindow.document.body.appendChild(previewBar);
    previewWindow.document.body.appendChild(iframe);
}

async function viewPDF() {
    var built = await generatePDF();
    if (!built) return; 

    var blob = built.doc.output('blob');
    openPreview(blob, built.fileName);
}

async function downloadPDF() {
    var built = await generatePDF();
    if (!built) return;

    var blob = built.doc.output('blob');
    createDownloadAnchor(blob, built.fileName); 
}


const downloadBtn = document.querySelector('.download-file');
const form = document.querySelector('.user-details');
//function getInputValues() {}

if (downloadBtn) {
    downloadBtn.addEventListener("click", function() {
        const phoneValue = document.getElementById('phone').value;
        const emailValue = document.getElementById('email').value;
        if (form.checkValidity() && checkPhoneInput(phoneValue) && checkEmailInput(emailValue)) {
            downloadPDF();
        } else {
            form.reportValidity();
            return;
        }
    })
}

// Check view button bug bug
const viewBtn = document.querySelector('.view-file');
if (viewBtn) {
    viewBtn.addEventListener("click", function() {
        const phoneValue = document.getElementById('phone').value;
        const emailValue = document.getElementById('email').value;
        if (form.checkValidity() && checkPhoneInput(phoneValue) && checkEmailInput(emailValue)) {
           viewPDF();
        } else {
            form.reportValidity();
            return;
        }
    })
} 

/* add-to-project-tool.liquid  */
function checkPhoneInput(value) {
    const errorElement = document.getElementById("phone-exception");
    const convertedNumber = Number(value);

    if (Number.isNaN(convertedNumber)) {
        errorElement.textContent = "Please enter a valid phone number." ;
        return false;
    } else {
        errorElement.textContent = '';
        return true;
    }  
}

document.getElementById("phone").addEventListener("input", function(e) {
    const target = e.currentTarget.value;
    checkPhoneInput(target);
})

function checkEmailInput(value) {
    const errorElement = document.getElementById("email-exception");
    const emailPattern = /^[^\s@]+@[^\s@]+\.(com|com\.au)$/;

    if (!emailPattern.test(value)) {
        errorElement.textContent = "Please enter a valid email";
        return false;
    } else {
        errorElement.textContent = '';
        return true;
    }  
}

document.getElementById("email").addEventListener("input", function(e) {
    const target = e.currentTarget.value;
    checkEmailInput(target);
})